<template>
  <div id="trackembed" :class="{'modal':modal}">
    <div class="col-xs-12 header">
      <div class="row">
        <div class="col-xs-6 col-lg-6 image">
          <div class="image-art">
            <div class="play-circle" v-if="canplay && track.spotify">
              <span class="play-circle-1"></span>
              <span class="play-circle-2"></span>
              <button class="play" :class="{'playing': playing}" v-html="(playing) ? pauseSVG : playSVG" @click="togglePlay()"></button>
            </div>
            <Album :track="track" :size="'large'" v-if="!$mobileDetect.mobile()" />
            <Album :track="track" v-if="$mobileDetect.mobile()" />
          </div>
          <audio v-show="false" ref="audio" v-if="track.spotify">
            <source :src="previewUrl" type="audio/mpeg">
          </audio>
        </div>
        <div class="col-xs-6 col-lg-2 related" v-if="!mobileSize">
          <span class="also-like" v-if="track.related.length">You may also like:</span>
          <ul v-if="track.related.length">
            <li v-for="t in track.related.slice(0, 4)" :key="t._id">
              <a :href="(!t.pre_save_spotify) ? t.slug : t.pre_save_spotify">
                <Album :track="t" :size="'small'" />
              </a>
            </li>
          </ul>
        </div>
        <div class="col-xs-12 col-lg-4 info">
          <h2 v-text="track.artist"></h2>
          <h1 v-text="track.title"></h1>
          <p v-text="track.description" class="description"></p>
          <div v-if="track.share_buy_url" class="share-buy row">
            <div class="col-md-12 col-lg-6">
              <p class="share-description" v-if="!following">
                Follow Musical Freedom<br/>
                <span v-if="track.artist">or </span><span v-text="track.artist"></span><br>
                on Spotify to download
              </p>
            </div>
            <div class="col-md-12 col-lg-6">
              <button class="btn" type="button" @click="followModal($event)" v-if="!following">
                <span v-if="!followValidating">Follow on Spotify</span>
                <span v-if="followValidating">Validating...</span>
              </button>
              <a class="btn download" :href="this.track.share_buy_url" target="_blank" v-if="following">Download</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12">
      <div class="links row">
        <div class="link col-xs-12 col-md-4 col-lg-3 type-spotify-white" v-if="track.spotify">
          <a target="_blank" :href="getLink('spotify')" @click="addPlaylist($event)">
            <span>Add to Spotify Playlist</span>
            <strong>Add to Spotify Playlist</strong>
          </a>
        </div>
        <div class="link col-xs-12 col-md-4 col-lg-3 type-spotify-white" v-if="track.spotify && hasSpotifyLink()">
          <a target="_blank" :href="getLink('spotify')" @click="triggerSpotifyLink">
            <span>Play now on Spotify</span>
            <strong>Play now on Spotify</strong>
          </a>
        </div>
        <div v-for="link in track.links" :key="link" :class="`type-${link}`" @click="openLink($event, link)" class="link col-xs-12 col-md-4 col-lg-3" v-if="link != 'spotify'">
          <a :href="getLink(link)" target="_blank" @click="onClickLink(typeTitle(link))" >
            <span>{{`${typeText(link)} on ${typeTitle(link)}`}}</span>
            <strong>{{`${typeText(link)} on ${typeTitle(link)}`}}</strong>
          </a>
        </div>
      </div>

      <TrackEmbedDialog :playlists="playlists" :addToPlaylist="addToPlaylist" v-if="showPlaylistModal && playlists.length" :close="() => { showPlaylistModal = false }" />
      <TrackEmbedFollow v-if="showFollowModal" :close="() => { showFollowModal = false; checkFollow() }" :spotify="track.share_buy_artist_id" />
      <div class="col-xs-6 col-lg-2 related related-mobile" v-if="mobileSize">
        <span class="also-like" v-if="track.related.length && mobileSize">You may also like:</span>
        <ul v-if="track.related.length && mobileSize">
          <li v-for="t in track.related.slice(0, 4)" :key="t._id">
            <a :href="(!t.pre_save_spotify) ? t.slug : t.pre_save_spotify">
              <Album :track="t" :size="'small'" />
            </a>
          </li>
        </ul>
      </div>
    </div>

  </div>

</template>

<script>
import playSVG from '../../static/images/play.svg'
import pauseSVG from '../../static/images/pause.svg'
import TrackEmbedDialog from './TrackEmbed/dialog'
import TrackEmbedFollow from './TrackEmbed/follow'
import Album from '@/components/Album'

export default {
  name: 'TrackEmbed',
  dependencies: ['DATA'],
  props: ['track', 'login', 'modal'],
  components: {
    TrackEmbedDialog,
    TrackEmbedFollow,
    Album
  },
  data () {
    return {
      playing: false,
      canplay: false,
      following: false,
      playSVG: playSVG,
      pauseSVG: pauseSVG,
      playlists: [],
      showPlaylistModal: false,
      showFollowModal: false,
      followValidating: false,
      mobileSize: false
    }
  },
  methods: {
    triggerSpotifyLink() {
      
    },
    checkSize () {
      this.mobileSize = window.innerWidth < 1000;
    },
    onClickLink(e) {
      fbq('track', 'clickStreamingService', { name: e });
    },
    hasSpotifyLink () {
      return this.track.links.indexOf('spotify') !== -1
    },
    typeTitle (type) {
      switch (type) {
        case '7digital':
          return '7digital'
        case 'amazon':
          return 'Amazon'
        case 'amazonmp3':
          return 'Amazon MP3'
        case 'applemusic':
          return 'Apple Music'
        case 'beatport':
          return 'Beatport'
        case 'deezer':
          return 'Deezer'
        case 'getmusic':
          return 'getmusic'
        case 'google-play':
          return 'Google Play'
        case 'itunes':
          return 'iTunes'
        case 'napster':
          return 'Napster'
        case 'soundcloud':
          return 'SoundCloud'
        case 'spotify':
          return 'Spotify'
        case 'telmore':
          return 'TELMORE Music'
        case 'tidal':
          return 'Tidal'
        case 'xboxmusic':
          return 'Groove Music'
        case 'youmusic':
          return 'YouSee Musik'
      }
    },
    typeText (type) {
      switch (type) {
        case 'amazon':
          return 'Go To'
        case '7digital':
        case 'beatport':
        case 'google-play':
        case 'itunes':
          return 'Download'
        default:
          return 'Play'
      }
    },
    openLink (evt, type) {
      if (evt) evt.preventDefault()
      window.open(this.getLink(type))
    },
    goLink ($event, track) {
      if ($event) event.preventDefault()
      this.$router.push({
        name: 'Track',
        params: {
          slug: track.slug
        }
      })
      this.$forceUpdate()
    },
    getLink (type) {
      if (type == 'spotify') {
        let content = this.track.spotify.split(":");
        return this.track.spotify;
        return `https://open.spotify.com/${content[1]}/${content[2]}`;
      }
      return this.track.linkfire + '/' + type
    },
    togglePlay () {
      if (this.playing) {
        this.$refs['audio'].pause()
        // this.$bus.$emit('spotify-player-resume')
      } else {
        this.$bus.$emit('spotify-player-pause')
        this.$refs['audio'].play()
      }
    },
    loadPlaylists () {
      this.showPlaylistModal = true
      this.$spotify.getUserPlaylists().then((r) => {
        this.playlists = r.items
      })
    },
    addToPlaylist (playlistId, ownerId) {
      this.showPlaylistModal = false
      let track = (/^spotify:/.test('spotify:', this.track.spotify) ? this.track.spotify : 'spotify:track:' + this.track.spotify)
      this.$spotify.addTracksToPlaylist(ownerId, playlistId, [this.track.spotify])
        .then((data) => {
          alert('Added tracks to playlist!')
        }, (err) => {
          alert('Something went wrong!')
          console.log('Something went wrong!', err)
        })
    },
    addPlaylist (evt) {
      if (evt) evt.preventDefault()

      if (this.$storage.get('spotifyAccessToken') === null) {
        this.login(() => {
          this.loadPlaylists()
        }, true)
      } else {
        this.loadPlaylists()
      }
    },
    followModal (evt) {
      if (evt) evt.preventDefault()

      if (this.$storage.get('spotifyAccessToken') === null) {
        this.login(() => {
          this.checkFollow(() => {
            if (this.following) {
              this.showFollowModal = false
            } else {
              this.showFollowModal = true
            }
          })
        })
      } else {
        this.showFollowModal = true
      }
    },
    checkFollow (cb) {
      let users = []
      let artists = []
      this.followValidating = false

      if (this.track.share_buy_artist_id && this.track.share_buy_artist_id.length > 0) {
        for (let i = 0; i < this.track.share_buy_artist_id.length; i++) {
          let element = this.track.share_buy_artist_id[i];
          if (element.indexOf('spotify:artist:') === 0) {
            artists.push(element.replace('spotify:artist:', ''))
          } else if (element.indexOf('spotify:user:')) {
            users.push(element.replace('spotify:user:', ''))
          }
        }
      }

      if (this.DATA.configs.track.spotify_id) {
        if (this.DATA.configs.track.spotify_id.indexOf('spotify:artist:') === 0) {
          artists.push(this.DATA.configs.track.spotify_id.replace('spotify:artist:', ''))
        } else if (this.DATA.configs.track.spotify_id.indexOf('spotify:user:')) {
          users.push(this.DATA.configs.track.spotify_id.replace('spotify:user:', ''))
        }
      }

      if (users.length) {
        this.$spotify.isFollowingUsers([users]).then((r) => {
          for (let i in r) {
            if (r[i]) {
              this.following = true
            }
          }
          if (cb) {
            cb()
          }
          this.followValidating = false
        })
      }
      if (artists.length) {
        this.$spotify.isFollowingArtists([artists.join(',')]).then((r) => {
          var b = 0
          for (let i in r) {
            if (r[i]) {
              b++
            }
          }
          if (b == r.length) {
            this.following = true
          }
          if (cb) {
            cb()
          }
          this.followValidating = false
        })
      }
    }
  },
  computed: {
    previewUrl () {
      return process.env.API_URL + 'spotifyPreview/' + this.track.spotify.replace('spotify:track:', '')
    }
  },
  watch: {
    track () {
      this.$forceUpdate()
    }
  },
  mounted () {
    this.$refs['audio'].onpause = () => {
      this.playing = false
    }
    this.$refs['audio'].onplay = () => {
      this.playing = true
    }
    this.$refs['audio'].addEventListener('canplay', () => {
      this.canplay = true
    }, false)

    if (this.$storage.get('spotifyAccessToken') !== null) {
      this.checkFollow()
    }
    window.addEventListener('resize', this.checkSize)
    this.checkSize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkSize)
    if (this.$refs.audio) {
      this.$refs['audio'].pause();
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables';

#trackembed {

  max-width: 1300px;
  margin: 0 auto;
  
  &:not(.modal) {
    @media screen and (min-width: 64em) {
      transform: scale(0.8);
      transform-origin: 50% 200px;
    }
  }

  .header {
    margin-top: 30px;
    margin-bottom: 20px;

    @media screen and (min-width: 1500px) {
      .image {
        flex-basis: 40%;
        max-width: 40%;
      }
      .related {
        flex-basis: 20%;
        max-width: 20%;
      }
      .info {
        flex-basis: 40%;
        max-width: 40%;
      }
    }

    @media screen and (min-width: 1024px) {
      .related {
        flex-basis: 27% !important;
        max-width: 27% !important;        
      }
      .info {
        margin-top: 50px;
      }
    }

    @media screen and (min-width: 75em) {
      .related {
        flex-basis: 16.667% !important;
        max-width: 16.667% !important;  
      }
      .info {
        margin-top: 0px;
      }
    }
  }

  .image {
    position: relative;

    .image-art {
      position: relative;
      width: 100%;
      padding-top: 100%;
      .album {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        .album-image {
          width: 100%;
        }
      }
    }

    .play-circle {
      border: 3px solid $yellow;
      float: left;
      padding: 94px 90px 26px 26px;
      border-radius: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }

    @keyframes play-animation {
      0%   { transform: rotate(225deg); }
      100% { transform: rotate(-135deg); }
    }

    .play-circle-1 {
      border: 12px solid $yellow;
      position: absolute;
      padding: 80px 80px 25px 25px;
      border-radius: 50%;
      z-index: 2;
      top: -6px;
      border-right-color: transparent;
      left: -6px;
      animation: play-animation 10s infinite;
    }

    .play-circle-2 {
      position: absolute;
      padding: 95px 91px 25px 25px;
      border-radius: 50%;
      top: 0px;
      left: 0;
      z-index: 1;
      background: #000;
      opacity: 0.75;
    }

    .play {
      cursor: pointer;
      background: transparent;
      fill: $white;
      border: none;
      outline: none;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 3;
      height: 100%;
      width: 100%;
      transition: 1s transform $easeInOutQuart;
      overflow: hidden;
      &:hover {
        transform: scale(1.5);
      }
      &:active {
        transform: scale(0.9);
      }

      g {
        transform: scale(2);
        transform-origin: 45px 42px;
      }

      &.playing {
        g {
          transform: scale(.3);
          transform-origin: 54px 54px;
        }
      }
      // transform: translate(-50%, -50%);
    }

    @keyframes play-line-animation {
      0%   { width: 0%; }
      100% { width: calc(100% - 44px); }
    }
  }

  .related {
    position: relative;

    .also-like {
      position: absolute;
      writing-mode: tb-rl;
      transform: rotate(-180deg);
      left: 18%;
      top: 0;
      background: #fff;
      padding-top: 40px;
      font-size: 16px;
      font-family: $font-bold;
    }
    ul {
      border-left: 1px solid #bfbfbf;
      border-right: 1px solid #bfbfbf;
      width: 66%;
      margin: 0 auto;
      display: block;
      a {
        background: $purple;
        display: block;
        width: 72%;
        margin: 0 auto 20px;
        height: auto;
        img {
          display: block;
          transition: 1s transform $easeInOutQuart;
          &:hover {
            transform: scale(0.95);
          }
          &:active {
            transform: scale(0.9);
          }
        }
      }
    }
  }

  .info {
    h2 {
      font-family: $font-bold;
      font-size: 30px;
    }
    h1 {
      font-family: $font-light;
      font-size: 80px;
    }
    p.description {
      font-size: 16px;
      line-height: 1.9em;
      padding-top: 33px;
      height: 270px;
      overflow: auto;
    }
    .share-buy {
      margin-top: 20px;

      @media screen and (max-width: 1500px) {
        margin-top: 0;
        div.col-lg-6 {
          flex-basis: 100%;
          max-width: 100%;
          margin-bottom: 20px;
        }
      }

      .share-description {
        font-family: $font-bold;
        font-size: 16px;
        margin-top: 7px;
        width: 100%;
      }
      .btn {
        cursor: pointer;
        box-sizing: border-box;
        border:  1px solid #e2e2e2;
        background: #00ce34;
        color: #fff;
        font-size: 16px;
        line-height: 2.6em;
        text-align: left;
        text-decoration: none;
        padding: 9px 10% 9px 5%;
        position: relative;
        outline: none;
        transition: color 0.3s linear;
        width: 100%;

        &.download {
          padding-left: 10%;
          &:hover {
            transform: scale(1.1);
          }
          &:active {
            transform: scale(0.9);
          }
          &:after {
            display: none;
          }
        }

        &:active {
          transform: scale(0.9);
        }

        &:hover {
          color: $black;
          &:after {
            filter: invert(0);
          }
        }

        &:after {
          content: "";
          background-image: url('/static/images/spotify.svg');
          transition: transform .2s linear;
          width: 35px;
          height: 35px;
          float: right;         float: right;
          background-repeat: no-repeat;
          background-position: 50% 50%;
          position: absolute;
          right: 10px;
          top: 50%;
          margin-top: -20px;
          filter: invert(100%);
          transition: filter 0.3s linear;
        }
      }
    }
  }

  .links {
    .link {
      margin-bottom: 23px;
      position: relative;

      @media screen and (min-width: 1500px) {
        flex-basis: 20%;
        max-width: 20%;
      }

      a {
        box-sizing: border-box;
        border:  1px solid #e2e2e2;
        color: #d3d3d3;
        float: left;
        font-size: 14px;
        line-height: 2.6em;
        text-decoration: none;
        width: 100%;
        padding: 9px 5%;
        padding-right: 25%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        position: relative;

        background: linear-gradient(to bottom, #fff 0%, #fff 50%, $purple 51%, $purple 100%);
        transition: background 0.3s $easeOutQuint;
        background-size: 100% 200%;

        span {
          transition: transform 0.3s $easeOutQuint;
          position: relative;
          display: block;
          &:after {
            display: none;
          }
        }

        strong {
          position: absolute;
          top: 0px;
          left: 0px;
          height: 100%;
          display: block;
          padding: 9px 5%;
          padding-right: 25%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
          transform: translate3d(0px, 10px, 0px);
          color: #fff;
          opacity: 0;

          &:after {
            display: none;
            content: "";
            width: 0px;
            height: 0px;
          }
        }

        span, strong {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;          
        }

        strong {
          box-sizing: border-box;
          padding-right: 25%;
          width: 100%;
        }

        &:hover {
          strong {
            transform: translate3d(0px, 0px, 0px);
            opacity: 1;
          }
          span {
            transform: translate3d(0px, -30px, 0px);
            opacity: 0;
          }
          background-position: 0% 100%;
        }

        // span {
        //   position: absolute;
        //   top: 0px;
        //   left: 0px;
        // }
      }

      @each $type in $service-types {
        &.type-#{$type} :after { background-image: url('/static/images/services/#{$type}.svg')}
      }
      &.type-spotify-white {
        a {
          background: linear-gradient(to bottom, #00ce34 0%, #00ce34 50%, #59ef7f 51%, #59ef7f 100%);
          background-size: 100% 200%;
          color: $white;
        }
        strong {
          color: #000;
          transition: transform 0.3s $easeOutBack, opacity 0.1s linear;
        }
        &:hover {
          a {
            color: $black;
            background-position: 0% 100%;
          }
          :after {
            filter: invert(0);
          }
        }
        :after {
          background-image: url('/static/images/spotify.svg');
          filter: invert(100%);
        }
      }
      :after {
        content: "";
        transition: transform .2s linear;
        width: 35px;
        height: 35px;
        float: right;
        background-repeat: no-repeat;
        background-position: 50% 50%;
        position: absolute;
        right: 16px;
        top: 50%;
        margin-top: -18px;
      }
    }
  }

  @media screen and (max-width: 64em) {
    .image {
      margin-top: 20px;
      width: 100%;
      flex-basis: 100%;
      max-width: unset;
    }
    .related {
      width: 100%;
      margin: 20px 0px;
      flex-basis: 100%;
      max-width: unset;
      border: none;
      padding: 0;
      .also-like {
        position: relative;
        left: inherit;
        top: inherit;
        writing-mode: inherit;
        transform: rotate(0);
        background: transparent;
        width: 100%;
        text-align: center;
        display: block;
        padding-top: 10px;
        font-size: 12px;
      }
      ul {
        width: auto;
        border: none;
        flex-direction: row;
        margin: 10px 0px;
        a {
          width: 96%;
          margin: 2%;
          height: auto;
          box-sizing: border-box;
        }
        li {
          display: inline-block;
          width: 50%;
        }
      }
    }
    .info {
      padding-top: 20px;
      h1 {
        font-size: 26px;
      }
      h2 {
        font-size: 20px;
      }
      .share-description {
        text-align: center;
        width: 100%;
      }
      p.description {
        height: auto;
      }
      button {
        width: 100%;
        margin-top: 20px;
        text-align: center !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TrackEmbed.vue